import React from "react";
import { colors } from "../colors/color";
import { Flex, FlexItem } from "../compositeComponents/FlexHelpers";
import { iconName, Icon } from "../icons/Icons";
import { Small } from "../typography/Body";
import { RadialPieChart } from "./RadialPieChart";


type CompletionPanelProps = {
    pct: number,
    completionText: string,
    missingText?: string,
    maxWidth?:string
}
export function CompletionPanel({pct, completionText, missingText, maxWidth}:CompletionPanelProps):JSX.Element
{
    return (
        <Flex flexDirection="row" gap={8} alignItems='center'>
            <FlexItem alignSelf="self-end">
                <RadialPieChart
                    segments={[
                        { value: pct, color: 'green' },
                        { value: 100 - pct, color: 'lightgray' }
                    ]}
                    dim="5rem"
                    maxWidth={maxWidth} 
                    value={pct.toString() + '%'}                
                />
            </FlexItem>

            <FlexItem alignSelf="self-end">
                <Flex flexDirection="column" gap={8}>

                    {completionText &&
                        <CompletedStatement text={completionText} />
                    }

                    {missingText &&
                        <MissingStatement text={missingText} />
                    }
                </Flex>
            </FlexItem>
        </Flex>
    );
}


export function SegmentedCompletionPanel({completionPct, segments, maxWidth}: {
    completionPct:number,
    segments:{value:number, color?:string, icon?:iconName, text?:string}[], 
    maxWidth?:string
}):JSX.Element
{

    return (
        <Flex flexDirection="row" gap={8} alignItems='center'>
            <FlexItem alignSelf="self-end">
                <RadialPieChart
                    segments={segments.map(s => ({
                        value:s.value, 
                        color:s.color || colors.radialChart.blue
                    }))}
                    dim="5rem"
                    maxWidth={maxWidth} 
                    value={completionPct.toString() + '%'}                
                />
            </FlexItem>

            <FlexItem alignSelf="self-end">
                <Flex flexDirection="column" gap={8}>
                    {segments.filter(s => !!s.text).map((segment, index) => (

                        <IconContentStatement
                            key={index}
                            icon={segment.icon}
                            iconColor={segment.color}
                            content={
                                <Small>{segment.text}</Small>
                            }
                        />
                    ))}
                </Flex>
            </FlexItem>
        </Flex>
    );
}


function CompletedStatement({text}: {text:string}):JSX.Element
{
    return (
        <IconContentStatement
            icon='status_ok'
            iconColor={colors.icon.success}
            content={
                <>
                    <Small>{text}</Small>
                </>
            } 
        />
    );
}

function MissingStatement({text}: {text:string}):JSX.Element
{
    return (
        <IconContentStatement
            icon='warning'
            iconColor={colors.icon.warning}
            content={
                <>
                    <Small>{text}</Small>
                </>
            } 
        />
    );
}

function IconContentStatement({icon, iconColor, content}: {icon?:iconName, iconColor?:string, content:JSX.Element}):JSX.Element
{
    return (
        <Flex gap={8} alignItems='center'>
            <div style={{width:24}}>
                {icon &&
                    <Icon name={icon} size='x-small' color={iconColor || colors.icon.default} />
                }
            </div>
            {content}
        </Flex>
    );
}